<app-tournament-header [showToolbar]="false"></app-tournament-header>

<ion-content>
  <div class="content-width">
    <ion-toolbar>
      <ion-segment #segment value="INDIVIDUAL" (ionChange)="segmentChanged($event)">
        <ion-segment-button value="INDIVIDUAL">
          <ion-label>Singles</ion-label>
        </ion-segment-button>
        <ion-segment-button value="PAIR">
          <ion-label>Doubles</ion-label>
        </ion-segment-button>
      </ion-segment>
    </ion-toolbar>

    <ion-toolbar>
      <ion-searchbar placeholder="Search" type="text" (ionInput)="getItems($event)" [debounce]="250"></ion-searchbar>
    </ion-toolbar>

    <ion-list>
      @for (participant of participants(); track $index) {
        <ion-item>
          <ion-label>{{participant.displayName}}</ion-label>
          <ion-button color="danger" (click)="deleteParticipant(participant._id)" fill="clear">
            @if (deletingParticipantId === participant._id) {
              <ion-spinner name="crescent"></ion-spinner>
            } @else {
              <ion-icon slot="icon-only" name="trash"></ion-icon>
            }
          </ion-button>
        </ion-item>
      }

      @let participantType = segment.value;

      <form [formGroup]="usersForm" (ngSubmit)="onSubmit(participantType)">
        <div formArrayName="users" class="ion-margin-top">
          @for (user of users.controls; let i = $index; track $index) {
            <div [formGroupName]="i">
              <ion-item>
                <ion-input autocapitalize label="First Name" label-placement="stacked" placeholder="First name" formControlName="first_name"></ion-input>
                <ion-input autocapitalize label="Last Name" label-placement="stacked" placeholder="Last name" formControlName="last_name"></ion-input>
              </ion-item>
            </div>
          }
        </div>

        <ion-button class="ion-margin" type="submit" [disabled]="usersForm.invalid" expand="block">
          Add
        </ion-button>
      </form>

    </ion-list>
  </div>

</ion-content>